import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import IMAGES from "../../../../../assets/images/images";
import TopBottomData from "./TopBottomData";
import { DownloadJSONExecutive } from "../../../../../domain/models/executive-summary/download-json-executive";

type Props = {
  downloadJSON: DownloadJSONExecutive[];
};

const TopBottomExecutiveSummary: React.FC<Props> = ({ downloadJSON }) => {
  const data = [
    {
      region_id: 1,
      region_name: "North1",
      area_id: 2,
      area_name: "Delhi1",
      hq_id: 3,
      hq_name: "Gurugram",
      sales_orders: 23,
      targer_orders: 24,
      target: 24500,
      sales: 24500,
      percentage: 123,
      growth: 42,
      channelPay: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
      channelPaisa: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
    },
    {
      region_id: 1,
      region_name: "North1",
      area_id: 2,
      area_name: "Delhi1",
      hq_id: 3,
      hq_name: "Gurugram",
      sales_orders: 23,
      targer_orders: 24,
      target: 24500,
      sales: 24500,
      percentage: 123,
      growth: 42,
      channelPay: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
      channelPaisa: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
    },
    {
      region_id: 1,
      region_name: "North1",
      area_id: 2,
      area_name: "Delhi1",
      hq_id: 3,
      hq_name: "Gurugram",
      sales_orders: 23,
      targer_orders: 24,
      target: 24500,
      sales: 24500,
      percentage: 123,
      growth: 42,
      channelPay: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
      channelPaisa: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
    },
    {
      region_id: 1,
      region_name: "North1",
      area_id: 2,
      area_name: "Delhi1",
      hq_id: 3,
      hq_name: "Gurugram",
      sales_orders: 23,
      targer_orders: 24,
      target: 24500,
      sales: 24500,
      percentage: 123,
      growth: 42,
      channelPay: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
      channelPaisa: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
    },
    {
      region_id: 1,
      region_name: "North1",
      area_id: 2,
      area_name: "Delhi1",
      hq_id: 3,
      hq_name: "Gurugram",
      sales_orders: 23,
      targer_orders: 24,
      target: 24500,
      sales: 24500,
      percentage: 123,
      growth: 42,
      channelPay: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
      channelPaisa: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
    },
    {
      region_id: 1,
      region_name: "North1",
      area_id: 2,
      area_name: "Delhi1",
      hq_id: 3,
      hq_name: "Gurugram",
      sales_orders: 23,
      targer_orders: 24,
      target: 24500,
      sales: 24500,
      percentage: 123,
      growth: 42,
      channelPay: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
      channelPaisa: {
        invoices: 24500,
        invoices_count: 23,
        order: 24500,
        order_count: 23,
        total: 100,
        active: 40,
      },
    },
  ];

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                bgcolor: "#E9EDF5",
                color: "#687182",
              }}
            >
              REGION
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                bgcolor: "#E9EDF5",
                color: "#687182",
              }}
            >
              AREA
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                bgcolor: "#E9EDF5",
                color: "#687182",
              }}
            >
              HEADQUARTER
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                bgcolor: "#E9EDF5",
                color: "#687182",
              }}
            >
              TARGET
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                bgcolor: "#E9EDF5",
                color: "#687182",
              }}
            >
              SALES
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                bgcolor: "#E9EDF5",
                color: "#687182",
              }}
            >
              %
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                bgcolor: "#E9EDF5",
                color: "#687182",
              }}
            >
              GROWTH
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#c6c7e5",
                padding: 0,
              }}
            >
              <img src={IMAGES.ChannelPay} alt="Channel Pay" />
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#c6c7e5",
                color: "white",
              }}
            >
              INVOICES
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#c6c7e5",
                color: "white",
              }}
            >
              ORDER
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#c6c7e5",
                color: "white",
              }}
            >
              ACTIVE
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#f4e5cf",
                padding: 0,
              }}
            >
              <img src={IMAGES.ChannelPaisa} alt="Channel Paisa" />
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#f4e5cf",
                color: "#687182",
              }}
            >
              INVOICES
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#f4e5cf",
                color: "#687182",
              }}
            >
              ORDER
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{
                border: "none",
                textAlign: "center",
                bgcolor: "#f4e5cf",
                color: "#687182",
              }}
            >
              ACTIVE
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow>
              <TopBottomData data={row} downloadJSON={downloadJSON} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TopBottomExecutiveSummary;
